module.exports = __webpack_public_path__ + "fonts/MADETheArtistSans.ea561cf1.woff";